import React, { useState } from 'react';
import { Form, AutoComplete } from 'antd';
import PropTypes from 'prop-types';
import './Variedade.scss';

const VariedadeField = (props) => {
  const {
    rules,
    name,
    label,
    value,
    edit,
  } = props;
  const [allState, setAllState] = useState({});
  const Suggestions = [
    '5RB855156',
    'AC87-3396',
    'CT022278',
    'CT049005',
    'CTC1',
    'CTC10',
    'CTC11',
    'CTC12',
    'CTC13',
    'CTC14',
    'CTC15',
    'CTC16',
    'CTC17',
    'CTC18',
    'CTC19',
    'CTC2',
    'CTC20',
    'CTC21',
    'CTC22',
    'CTC23',
    'CTC24',
    'CTC25',
    'CTC3',
    'CTC4',
    'CTC5',
    'CTC6',
    'CTC7',
    'CTC8',
    'CTC9',
    'CTC9001',
    'CTC9002',
    'CTC9003',
    'CTC9004',
    'CTC9005',
    'CTC9005HP',
    'CV6654',
    'CV6984',
    'CV7231',
    'CV7870',
    'IAC',
    'IAC86-2210',
    'IAC86-2480',
    'IAC87-3396',
    'IAC91-1099',
    'IAC91-2195',
    'IAC91-2218',
    'IAC91-515',
    'IAC91-5155',
    'IAC95-5000',
    'IAC97-4039',
    'IACCT07-8008',
    'IACSP 95-5094',
    'IACSP01-3127',
    'IACSP01-5503',
    'IACSP93-3046',
    'IACSP93-6006',
    'IACSP94-2094',
    'IACSP94-2101',
    'IACSP94-4004',
    'IACSP95-3028',
    'IACSP95-5000',
    'IACSP95-5094',
    'IACSP96-2042',
    'IACSP96-3060',
    'IACSP96-7569',
    'IACSP97-4039',
    'P83-5073',
    'RB005014',
    'RB005983',
    'RB015177',
    'RB015935',
    'RB015935S',
    'RB03-6152',
    'RB036152',
    'RB72454',
    'RB825336',
    'RB835054',
    'RB835089',
    'RB835089CTC9002',
    'RB835486',
    'RB845210',
    'RB845257',
    'RB85503',
    'RB855035',
    'RB855036',
    'RB855113',
    'RB855156',
    'RB855156B855453',
    'RB855453',
    'RB855536',
    'RB855546',
    'RB863129',
    'RB865230',
    'RB867515',
    'RB872552',
    'RB925345',
    'RB92579',
    'RB928064',
    'RB93509',
    'RB935210',
    'RB935744',
    'RB937570',
    'RB945273',
    'RB945961',
    'RB946015',
    'RB94602',
    'RB946022',
    'RB946903',
    'RB965518',
    'RB965602',
    'RB965902',
    'RB965911',
    'RB965917',
    'RB966229',
    'RB966928',
    'RB975157',
    'RB975201',
    'RB975242',
    'RB975375',
    'RB975932',
    'RB975939',
    'RB975952',
    'RB977619',
    'RB985476',
    'RB986419',
    'RB988082',
    'SP 80-1520',
    'SP 80-185',
    'SP 84-5560',
    'SP 90-3723',
    'SP 91-1397',
    'SP 91-1597',
    'SP 01-3127',
    'SP 01-5503',
    'SP 77-5181',
    'SP 79-1011',
    'SP80-1816',
    'SP80-1842',
    'SP80-280',
    'SP80-328',
    'SP80-3280',
    'SP80-3480',
    'SP801842',
    'SP81-3250',
    'SP83-2847',
    'SP83-5073',
    'SP832847',
    'SP84-1201',
    'SP84-1431',
    'SP84-2025',
    'SP85-3877',
    'SP85-5077',
    'SP86-155',
    'SP86-42',
    'SP87-344',
    'SP87-365',
    'SP87-396',
    'SP89-1115',
    'SP90-1107',
    'SP90-1161',
    'SP90-1638',
    'SP90-3414',
    'SP90-3723',
    'SP91-1049',
    'SP91-1049SP91-3011',
    'SP91-1285',
    'SP91-1397',
    'SP91-1597',
    'SP91-285',
    'SP91-3011',
    'SP91-3440',
    'SP911397',
    'SP93-3046',
    'SP93-6006',
    'SP94-2094',
    'SP94-2101',
    'SP94-4004',
    'SP95-5000',
    'SP95-5094',
    'SP96-2042',
    'SP96-3060',
    'SP96-7569',
  ];

  const renderAutocomplete = () => {
    const autocompleteFind = (text) => (
      Suggestions
        .filter((v) => v.toLowerCase().includes(text.toLowerCase())).map((v) => (
          { label: v, value: v, key: v }
        ))
    );

    const onSearch = (searchText) => {
      setAllState((previous) => {
        return ({
          ...previous,
          [`options${name}`]: !searchText ? [] : autocompleteFind(searchText),
        });
      });

      return allState;
    };

    return (
      <Form.Item
        label={<span className="field-title-text">{label}</span>}
        name={name}
        rules={rules}
        initialValue={value || undefined}
      >
        <AutoComplete
          options={allState[`options${name}`] || []}
          onSearch={onSearch}
          disabled={edit}
        />
      </Form.Item>
    );
  };

  return (
    renderAutocomplete()
  );
};

VariedadeField.defaultProps = {};
VariedadeField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.element.isRequired,
  edit: PropTypes.bool,
};

export default VariedadeField;
